/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
import { getFormattedMessage, getTruncateStyles } from '../../utils';
const getStyles = maxLines => css({
  color: "var(--ds-text-subtlest, #626F86)",
  fontSize: '0.75rem',
  lineHeight: '1rem',
  whiteSpace: 'normal'
}, getTruncateStyles(maxLines));

/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */
const Text = ({
  content,
  maxLines = 1,
  message,
  name,
  overrideCss,
  testId = 'smart-element-text'
}) => {
  if (!message && !content) {
    return null;
  }
  return jsx("span", {
    css: [getStyles(maxLines), overrideCss],
    "data-separator": true,
    "data-smart-element": name,
    "data-smart-element-text": true,
    "data-testid": testId
  }, getFormattedMessage(message) || content);
};
export default Text;